/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p[_ngcontent-%COMP%]{margin-left:10px;margin-bottom:2px;font-weight:300;line-height:46px;font-family:'Helvetica Neue',sans-serif}@media (max-width:599px){p[_ngcontent-%COMP%]{font-size:30px}}@media (min-width:600px){p[_ngcontent-%COMP%]{font-size:38px}}.estimated-value[_ngcontent-%COMP%]{color:#1f355e}.no-result[_ngcontent-%COMP%]{color:#acaaaa}"];
export { styles as styles };
